export default "__VITE_ASSET__375be66f__"